"use strict";
// Budget type definitions — mirrors Django DRF API response shapes.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=budget.js.map